// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { circleSlash16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-circle-slash': IconCircleSlash;
    }
}

/**
 * The icon component for the 'circleSlash' icon
 */
export class IconCircleSlash extends Icon {
    public constructor() {
        super(circleSlash16X16);
    }
}

registerIcon('icon-circle-slash', IconCircleSlash);
export const iconCircleSlashTag = 'nimble-icon-circle-slash';
